import  ApiDataService  from './ApiDataService'

  const saveExam = data => {
    return ApiDataService.post("examanswer", data);
  };
  

export default {saveExam};